export const {
  CKEDITOR_DELETE_ENDPOINT,
  CKEDITOR_UPLOAD_ENDPOINT,
  EMAIL_APPLICATION_ENDPOINT,
  EMAIL_ENDPOINT,
  FILE_PATH,
  GRAPHQL_SERVER,
  NEWS_HEADER_IMAGE_PATH,
  NEWS_THUMBNAIL_IMAGE_PATH,
  SERVER_ENDPOINT,
  TRANSFORM_REQUEST,
  UPLOAD_IMAGE_ENDPOINT,
  // WS_ENDPOINT,
} = {
  CKEDITOR_DELETE_ENDPOINT: "api/delete-uploaded-ckeditor",
  CKEDITOR_UPLOAD_ENDPOINT: "api/upload-ckeditor",
  EMAIL_APPLICATION_ENDPOINT: "api/email-application",
  EMAIL_ENDPOINT: "api/email",
  FILE_PATH: "storage/",
  GRAPHQL_SERVER: "http://backend.itcfinance.com/graphql",
  // GRAPHQL_SERVER: "http://webitcbackend.com:81/graphql",
  NEWS_HEADER_IMAGE_PATH: "images/header/",
  NEWS_THUMBNAIL_IMAGE_PATH: "images/thumbnail/",
  SERVER_ENDPOINT: "http://backend.itcfinance.com/",
  // SERVER_ENDPOINT: "http://webitcbackend.com:81/",
  TRANSFORM_REQUEST: (jsonData = {}) =>
    Object.entries(jsonData)
      .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
      .join("&"),
  UPLOAD_IMAGE_ENDPOINT: "api/upload",
  // WS_ENDPOINT: "ws://localhost:4201/graphql",
};
